import React from 'react';
import { WithIcon } from './WithIcon';

export const IconHamburger = WithIcon(
  'Hamburger',
  '0 0 1024 1024',
  <path
    transform="scale(1, -1) translate(0, -960)"
    d="M4 784h1016v-60h-1016v60zM4 478h1016v-60h-1016v60zM4 172h1016v-60h-1016v60z"
  />
);
